import React from 'react'
import { mergePartner } from '../../utils'
import { User } from '../user'

const PartnerView = ({internals, externals, onRemove, onRemoveExternal, onEdit = () => {}}) => {
  const merged = mergePartner(internals, externals)

  const handleEdit = (p) => {
    onEdit(p.id)
  }

  const handleDelete = (p) => {
    if(p.type === 'internal'){
      onRemove(p.id, p.pkId)
    } else {
      onRemoveExternal(p.id ? p.id : p)
    }
  }

  return (
    <>
      {
        (merged && merged.length > 0) &&
        merged.map(p => p.name && (
          <div
            key={p.id}
            className="flex items-center justify-between mb-2"
            // onClick={() => console.log(p)}
          >
            <div className="pr-2">
              <User
                small
                name={p.name}
                image={p.image || false}
              />
            </div>
            {
              p.type === 'external' &&
              <p
                className="text-xs text-primary underline cursor-pointer pointer-events-auto"
                onClick={() => handleEdit(p)}
              >
                Edit
              </p>
            }
            <p
              className="text-xs text-gray-999 underline cursor-pointer pointer-events-auto"
              onClick={() => handleDelete(p)}
            >
              Delete
            </p>
          </div>
        ))
      }
    </>
  )
}

export { PartnerView }
